/* eslint-disable */
import mutations from './mutations'
import actions from './actions'

export default {
    state: {
        informations: {
            picture: require("@/assets/images/users/user.jpg"),
            permissions: [],
            connected: false,
            leftPaidVacations: 0,
        },
        listFormModel: {},
        userInfoModal: false,
        userId: null,
        isCollapse: false,
        listTableState:{
            page : 1,
            perPage: 10,
            field : 'Date de création',
            ascending: false,
        },
        notifications: [],
    },
    mutations,
    actions,
};
